// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"f93fe811","620":"146839a2","665":"146839a2"}[chunkId] + ".chunk.css";
};